import { type FC } from "react";

import previewInReviewSvg from "@app-assets/svg/preview-in-review.svg";

import { type PreviewAspectRatio } from "../models";

import { Container, HeaderSection, Logo, TextSection } from "./PreviewInReviewComponent.styles";
import { PreviewInReviewApprovalText, PreviewInReviewTitle } from "./messages.generated";

interface PreviewInReviewComponentProps {
    aspectRatio: PreviewAspectRatio;
}

export const PreviewInReviewComponent: FC<PreviewInReviewComponentProps> = ({ aspectRatio }) => (
    <Container aspectRatio={aspectRatio}>
        <Logo alt="Preview in review icon" src={previewInReviewSvg} aspectRatio={aspectRatio} />
        <HeaderSection>
            <PreviewInReviewTitle />
        </HeaderSection>
        <TextSection>
            <PreviewInReviewApprovalText />
        </TextSection>
    </Container>
);
